import ButtonComponent from '../../../../atoms/button/index.jsx'
import {
  buttonTypeOptions,
  buttonVariantOptions
} from '../../../../atoms/button/constants.js'
import { Help } from '../../../../atoms/icons/menu/index.js'
import { IconContainer } from '../../styled-components.js'

export const SupportComponent = ({ onClick = () => {} }) => {
  return (
    <IconContainer>
      <ButtonComponent
        variant={buttonVariantOptions['GHOST-INVERTED']}
        buttonType={buttonTypeOptions['ICON-ONLY']}
        onClick={onClick}
      >
        <Help />
      </ButtonComponent>
    </IconContainer>
  )
}
